/**
 * Card style mappings. No styles in the component; all class maps live here.
 *
 * @internal Used by Card atom only.
 */

import { cn } from '@/utils/cn';
import type { CardPadding, CardRounded, CardVariant } from './Card.types';

export const VARIANT_CLASSES: Record<CardVariant, string> = {
  outlined: 'bg-white border border-light-lin/50 shadow-sm',
  elevated: 'bg-white border border-light-lila/30 shadow-md',
  subtle: 'bg-background-gray border border-light-lin/50 shadow-sm',
  custom: '',
};

export const PADDING_CLASSES = {
  none: '',
  sm: 'p-3',
  md: 'p-4 sm:p-5',
  lg: 'p-5 sm:p-6',
} as const;

export const ROUNDED_CLASSES: Record<CardRounded, string> = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  full: 'rounded-full',
};

export function getCardClasses(
  variant: CardVariant,
  padding: CardPadding,
  rounded: CardRounded,
  className?: string
): string {
  return cn(
    'm-1',
    VARIANT_CLASSES[variant],
    PADDING_CLASSES[padding],
    ROUNDED_CLASSES[rounded],
    className
  );
}
